import React from "react";
import "./style.css";
import { Title, Text, GreenText } from "../common/styled";
import Footer from "../common/Footer";
import FormContato from "./components/FormContato";
import mediaQuery from "../common/mediaQuery";
import { Grid, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GoogleMaps from "./components/GoogleMaps";
import ScrollAnimation from "react-animate-on-scroll";
import Loading from "./components/Loading";
import styled, { keyframes } from "styled-components";
import { lightSpeedIn, fadeIn } from "react-animations";

const lighspeedIn = keyframes`${lightSpeedIn}`;

const LightSpeedIn = styled.div`
  animation: 2s ${lighspeedIn};
`;

const fadyIn = keyframes`${fadeIn}`;

const FadeIn = styled.div`
  animation: 1.5s ${fadyIn};
`;

export default ({
  language,
  text,
  handleInputChange,
  nome,
  telefone,
  setor,
  email,
  mensagem,
  handleSubmit,
  showLoading,
  showForm,
  errContato,
  newMessage,
  tryAgain,
}) => {
  const useStyles = makeStyles({
    button: {
      backgroundColor: "#58b711",
      color: "#fff",
      fontWeight: 600,
      paddingBottom: "1vh",
      paddingTop: "1.2vh",
      paddingLeft: "1vw",
      paddingRight: "1vw",
      borderRadius: 10,
      marginRight: "1.2vw",
      marginTop: "5vh",
      fontSize: "2vh",

      "&:hover": {
        backgroundColor: "#3e820c",
      },
    },
  });

  const classes = useStyles();

  const { small } = mediaQuery();

  return (
    <div className="Body-wrapper" style={{ paddingTop: 50 }}>
      <Grid
        alignItems="center"
        alignContent="center"
        className={small ? "ContainerFormMobile" : "ContainerForm"}
      >
        {showForm && !errContato && (
          <div>
            <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
              <Title align="center" color="#58b711" size="4.5vh" weight="700">
                {text.getTextoFill()}
              </Title>
            </ScrollAnimation>
            <form className={small ? "FormContatoMobile" : "FormContato"}>
              <ScrollAnimation animateIn="bounceInRight" animateOnce={true}>
                <FormContato
                  text={text}
                  nome={nome}
                  setor={setor}
                  email={email}
                  mensagem={mensagem}
                  telefone={telefone}
                  handleInputChange={handleInputChange}
                  handleSubmit={handleSubmit}
                  showLoading={showLoading}
                />
              </ScrollAnimation>
            </form>
          </div>
        )}

        {showLoading && !errContato && (
          <div className="LoadingContainer">
            <Loading />
          </div>
        )}

        {!showLoading && !showForm && !errContato && (
          <div className="CheckContainer">
            <FadeIn>
              <img
                src={require("../../images/contato/checked.png")}
                alt=""
                style={{ height: "20vh", width: "auto", marginBottom: "5vh" }}
              />
            </FadeIn>
            <LightSpeedIn>
              <GreenText size="4vh" weight="900">
                {" "}
                {text.getTextSuccess()}{" "}
              </GreenText>
            </LightSpeedIn>

            <FadeIn>
              <Button className={classes.button} onClick={() => newMessage()}>
                {" "}
                {text.getTextNewContato()}{" "}
              </Button>
            </FadeIn>
          </div>
        )}

        {!!errContato && (
          <div className="ErroContainer">
            <div class="ErroWindow">
              <Title size="8vh" color="red" weight="1000">
                {" "}
                Ooops...
              </Title>
              <Title size="3vh" weight="400" color="#222" marginTop="4vh">
                {text.getError()}
              </Title>
              <Title size="3vh" weight="400" color="#222">
                {errContato}
              </Title>

              <Button onClick={() => tryAgain()} className={classes.button}>
                {text.getTryAgain()}
              </Button>
            </div>
          </div>
        )}
      </Grid>

      <Grid
        container
        className="MatrizContainer"
        xs={12}
        justify="center"
        alignItems="center"
        alignContent="center"
      >
        <Grid
          style={{
            borderRight: "solid",
            borderWidth: 1.3,
            borderColor: "#58b711",
          }}
          item
          xs={12}
          sm={6}
          className="Matriz"
          justify="center"
          alignItems="center"
          alignContent="center"
        >
          <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
            <Text align="center" weight="800" size="4vh" color="#222">
              {text.getTextoMatriz().br[0]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().br[1]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().br[2]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().br[3]}
            </Text>
            <Text
              style={{ marginTop: "2vh" }}
              align="center"
              color="#222"
              size="3vh"
              weight="600"
            >
              {text.getTextoMatriz().br[4]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().br[5]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().br[6]}
            </Text>

            <div class={small ? "MapContainerMobile" : "MapContainer"}>
              <GoogleMaps
                lat={-22.5180515}
                lon={-44.1022595}
                place="City Connect - Soluções em Tecnologia"
              />
            </div>
          </ScrollAnimation>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          className="Matriz"
          style={{
            borderLeft: "solid",
            borderWidth: 1.3,
            borderColor: "#58b711",
          }}
          justify="center"
          alignItems="center"
          alignContent="center"
        >
          <ScrollAnimation animateIn="slideInRight" animateOnce={true}>
            <Text align="center" weight="800" size="4vh" color="#222">
              {text.getTextoMatriz().us[0]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().us[1]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().us[2]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().us[3]}
            </Text>
            <Text
              style={{ marginTop: "2vh" }}
              align="center"
              color="#222"
              size="3vh"
              weight="600"
            >
              {text.getTextoMatriz().us[4]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().us[5]}
            </Text>
            <Text align="center" color="#222" size="3vh" weight="100">
              {text.getTextoMatriz().us[6]}
            </Text>
            <div class={small ? "MapContainerMobile" : "MapContainer"}>
              <GoogleMaps
                lat={28.6645779}
                lon={-81.3463578}
                place="City Connect - Solutions in Tecnology"
              />
            </div>
          </ScrollAnimation>
        </Grid>
      </Grid>

      <Footer text={text} language={language} />
    </div>
  );
};
